module.exports = __webpack_public_path__ + "static/media/rabbit-fast.81365460.svg";